import { CalendarConfigs } from "chakra-dayzed-datepicker/dist/utils/commonTypes";


const configs: CalendarConfigs = {
  dateFormat: 'dd/MM/yyyy',
  dayNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  firstDayOfWeek: 0
}

export default configs;